/**
 * Текст помилки збереження перевизначення (чиста функція): застаріла версія (412) чи конфлікт (409) — `conflict`; валідація (400) — перше
 * повідомлення сервера з шляхом до ключа патча; інакше — повідомлення помилки або `fallback`.
 */
export function saveErrorText(error: unknown, conflict: string, fallback: string): string {
  const e = (error && typeof error === 'object' ? error : {}) as { status?: number; message?: string; errors?: Record<string, string[]> };
  if (e.status === 412 || e.status === 409) return conflict;
  const first = Object.entries(e.errors ?? {}).find(([, list]) => list?.length);
  if (first) return `${first[1]![0]} (${first[0]})`;
  return e.message && !/^HTTP \d+$/.test(e.message) ? e.message : fallback;
}
